module.exports = __webpack_public_path__ + "static/media/plainrice.85c8988f.jpg";